import { useState } from "react";
import { supabase } from "./supabaseClient";

export default function Login() {
  const [loading, setLoading] = useState(false);
  const [email, setEmail] = useState("");

  const handleLogin = async (e) => {
    e.preventDefault();

    try {
      setLoading(true);
      const { error } = await supabase.auth.signInWithOtp({
        email,
        options: {
          emailRedirectTo: process.env.REACT_APP_REDIRECT_URL,
        },
      });
      if (error) throw error;
      alert("Check your email for the login link!");
    } catch (error) {
      alert(error.error_description || error.message);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="grid h-screen place-items-center">
      <div className="col-6 form-widget" aria-live="polite">
        {loading ? (
          "Sending magic link..."
        ) : (
          <div className="bg-white rounded px-8 pt-6 pb-8 mb-4 flex flex-col">
            <img
              src="images/ribbon-award.png"
              alt="Ribbon"
              className="rounded mb-5"
            />

            <form onSubmit={handleLogin}>
              <div className="mb-4">
                <label
                  className="block text-grey-darker text-sm mb-1"
                  htmlFor="email"
                >
                  Email
                </label>
                <input
                  className="shadow appearance-none border rounded w-full py-2 px-3 text-grey-darker"
                  id="email"
                  type="email"
                  placeholder="example@ribbon.cool"
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                />
              </div>

              <button className="bg-indigo-500 text-white font-bold w-full py-2 px-4 rounded">
                Sign In
              </button>
              {/* </div> */}
            </form>
          </div>
        )}
      </div>
    </div>
  );
}
